import styled from '@emotion/styled';
import { useCallback, useState } from 'react';

import Plus from '@/images/plus.svg';

import theme from '@/theme';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';
import { AssetCard } from './AssetCard';

const StyledAssetCard = styled(AssetCard)`
    background: ${({ theme }) => theme.colors.black[100]};
    border-radius: 10px;
    display: flex;
    padding: 0;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => theme.colors.secondary[900]};
    text-align: center;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.28px;

    :hover {
        background-color: ${({ theme }) => theme.colors.black[200]};
    }
` as typeof AssetCard;

const AddNewContainer = styled('div', {
    shouldForwardProp: prop => prop !== 'textFlowDirection',
})<{ textFlowDirection: 'row' | 'column' }>`
    display: flex;
    flex-direction: ${({ textFlowDirection }) => textFlowDirection};
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 100%;
    width: 100%;
    border-radius: 8px;
`;

const IconCircle = styled('div')`
    background-color: ${({ theme }) => theme.colors.black[100]};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
`;

export interface IAssetCardProps {
    onClick?: (e: any, toggleLoad: (on: boolean) => void) => void;
    className?: string;
    svgSize?: string;
    svgColor?: string;
    label?: string;
    loading?: boolean;
    textFlowDirection?: 'row' | 'column';
    progressColor?: 'primary' | 'secondary';
    testId?: string;
}

export function AddAssetCard({
    onClick,
    className,
    svgSize,
    loading,
    testId,
    svgColor = theme.colors.secondary.main,
    label = 'Upload',
    textFlowDirection = 'column',
    progressColor = 'primary',
}: IAssetCardProps) {
    const [isLoading, setIsLoading] = useState(false);

    const onClickCallback = useCallback((e: any) => onClick?.(e, setIsLoading), [onClick]);

    return (
        <StyledAssetCard
            item="new"
            className={className}
            variant={isLoading || loading ? 'loading' : 'default'}
            progressColor={progressColor}
            onClick={onClickCallback}
            testId={testId}>
            <AddNewContainer textFlowDirection={textFlowDirection}>
                <IconCircle>
                    <MaskedIcon src={Plus} size={svgSize || '20px'} color={svgColor} />
                </IconCircle>
                {label}
            </AddNewContainer>
        </StyledAssetCard>
    );
}
